import { useEffect } from 'react';
import T from 'i18n-react';

import { CrossIcon } from '@motorway/mw-highway-code';
import { Chip } from '@motorway/mw-highway-code/pre-alpha';

import cypressIds from 'Components/cypress_ids.json';
import { useToggleSavedFilter } from 'Components/SavedSearch/useToggleSavedFilter';
import texts from 'Components/texts.json';
import {
	useLastActiveFilterBeforeEdit,
	useSetLastActiveFilterBeforeEdit,
} from 'Stores/SavedFiltersActionsStore/SavedFiltersActionsStore';
import { useCurrentFilter, useGetSavedFilter, useSetCurrentFilter } from 'Stores/SavedFiltersStore/SavedFiltersStore';
import { applyCypressData } from 'Utilities/helpers';

T.setTexts(texts);

interface ActiveSavedSearchProps {
	onClick?: () => void;
	onMouseEnter?: () => void;
}

export const ActiveSavedSearch: React.FC<ActiveSavedSearchProps> = ({ onClick, onMouseEnter }) => {
	const currentFilterId = useCurrentFilter();
	const getSavedFilter = useGetSavedFilter();
	const onToggleSavedFilter = useToggleSavedFilter();
	const lastActiveFilterBeforeEdit = useLastActiveFilterBeforeEdit();
	const setLastActiveFilterBeforeEdit = useSetLastActiveFilterBeforeEdit();
	const setCurrentFilter = useSetCurrentFilter();
	const currentFilter = getSavedFilter(currentFilterId);

	const filterName = currentFilter?.name;

	const onChange = () => {
		if (currentFilterId) {
			onToggleSavedFilter(currentFilterId);
		}
		onClick?.();
	};

	useEffect(() => {
		if (lastActiveFilterBeforeEdit && setLastActiveFilterBeforeEdit) {
			setCurrentFilter(lastActiveFilterBeforeEdit);
			setLastActiveFilterBeforeEdit(undefined);
		}
	}, [lastActiveFilterBeforeEdit, setCurrentFilter, setLastActiveFilterBeforeEdit]);

	return (
		<Chip
			selected
			{...{ onMouseEnter, ...applyCypressData(cypressIds.inputs.savedFilter) }}
			aria-label={`${T.translate('savedSearch.savedSearchPill.ariaUnsetFilter')}`}
			icon={CrossIcon}
			label={filterName}
			onClick={onChange}
		/>
	);
};
